import { useEffect } from "react";
import { useTheme } from "../context/ThemeContext"; // 🔥 Dark mode támogatás

const DeleteOfferModal = ({ isOpen, onClose, onConfirm, offer }) => {
  const { darkMode } = useTheme(); // 🔥 Dark mode állapot lekérése

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen || !offer) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose(); // 🔥 Külső kattintásra bezárás
        }
      }}
    >
      <div
        className={`p-6 rounded-lg shadow-lg w-96 ${
          darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"
        }`}
        onClick={(e) => e.stopPropagation()} // 🔥 Megakadályozzuk, hogy a kattintás áthaladjon
      >
        <h2
          className={`text-xl text-center font-semibold mb-4 ${
            darkMode ? "text-red-400" : "text-red-600"
          }`}
        >
          Sigur doriți să ștergeți oferta?
        </h2>
        <p className="mb-4 text-center">
          Oferta asociată clientului{" "}
          <span className="font-semibold">{offer.customerName}</span> va fi
          ștearsă definitiv.
        </p>
        <div className="flex justify-between w-full">
          <button
            onClick={onClose}
            className={`px-4 py-2 rounded-lg transition ${
              darkMode
                ? "bg-gray-700 hover:bg-gray-600 text-white"
                : "bg-gray-300 hover:bg-gray-400 text-black"
            }`}
          >
            Anulează
          </button>
          <button
            onClick={() => onConfirm(offer.id)}
            className={`px-4 py-2 rounded-lg transition ${
              darkMode
                ? "bg-red-700 hover:bg-red-600 text-white"
                : "bg-red-600 hover:bg-red-500 text-white"
            }`}
          >
            Șterge
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteOfferModal;
